import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, Edit, AlertTriangle, CheckCircle, Inbox } from 'lucide-react';

const ActivityCard = ({ title, data, icon: Icon }) => {
  const activities = Array.isArray(data?.activities) ? data.activities : [];

  const getActivityIcon = (type) => {
    switch (type) {
      case 'created':
        return <Plus className="w-4 h-4" />;
      case 'updated':
        return <Edit className="w-4 h-4" />;
      case 'expired':
        return <AlertTriangle className="w-4 h-4" />;
      default:
        return <CheckCircle className="w-4 h-4" />;
    }
  };

  const getActivityColor = (color) => {
    const colors = {
      success: 'bg-success-100 text-success-600',
      primary: 'bg-primary-100 text-primary-600',
      danger: 'bg-danger-100 text-danger-600',
      warning: 'bg-warning-100 text-warning-600',
    };
    return colors[color] || colors.primary;
  };

  return (
    <div className="card">
      <div className="card-header">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center text-primary-600">
            <Icon className="w-5 h-5" />
          </div>
          <div>
            <h3 className="card-title">{title}</h3>
            <p className="card-subtitle">Últimas atividades do sistema</p>
          </div>
        </div>
        {activities.length > 0 && (
          <Link to="/licenses" className="btn btn-outline btn-sm">
            Ver todas
          </Link>
        )}
      </div>
      <div className="card-content">
        {activities.length === 0 ? (
          <div className="flex flex-col items-center justify-center gap-3 py-10 text-center">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 text-gray-400">
              <Inbox className="h-6 w-6" />
            </div>
            <p className="text-sm font-medium text-gray-700">Nenhuma atividade recente</p>
            <p className="max-w-sm text-sm text-gray-500">
              As licenças e processos cadastrados aparecerão aqui.
            </p>
          </div>
        ) : (
          <div className="space-y-4">
            {activities.map((activity) => (
              <div key={String(activity.id)} className="flex items-center gap-4 rounded-lg bg-gray-50 p-4">
                <div
                  className={`flex h-10 w-10 items-center justify-center rounded-full ${getActivityColor(activity.color)}`}
                >
                  {getActivityIcon(activity.type)}
                </div>
                <div className="flex-1">
                  <h4 className="font-medium text-gray-900">{activity.title}</h4>
                  <p className="text-sm text-gray-600">{activity.description}</p>
                  {activity.time && activity.time !== '—' && (
                    <p className="mt-1 text-xs text-gray-500">{activity.time}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityCard;
